import CryptoJS from "crypto-js";
import * as CustomToast from '../components/CustomToastMessage';
import { TEXT_CASE } from "../common/constants";


export const requestHandler = async (api, setLoading, onSuccess, onError, showToast = true) => {
  try {
    setLoading && setLoading(true);
    const response = await api();
    const { data } = response;

    if (data?.success) {
      onSuccess(data);
    }
  } catch (error) {
    if ([401].includes(error?.status)) {
      localStorage.clear();
      setTimeout(() => {
        window.location.href = "/login";
      }, 1000);
    }
    if (showToast) {
      CustomToast.error(error.response?.data?.message || "Error, please try again...!");
    }
    onError(error);
  } finally {
    setLoading && setLoading(false);
  }
};

const encryptionKey = process.env.REACT_APP_CRYPTO_JS_KEY;

export const encryptAndStoreLoc = (key, data) => {
  try {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      encryptionKey
    ).toString();
    localStorage.setItem(key, encryptedData);
    return true;
  } catch (error) {
    console.error("Encryption failed:", error);
    return false;
  }
};

export const decryptFromStoreLoc = (key) => {
  try {
    const encryptedData = localStorage.getItem(key);
    if (encryptedData) {
      const bytes = CryptoJS.AES.decrypt(encryptedData, encryptionKey);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptedData;
    }
    return null;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

export const convertCase = (text, caseType) => {
  if (!text) return "";

  switch (caseType) {
    case TEXT_CASE.UPPERCASE:
      return text.toUpperCase();
    case TEXT_CASE.LOWERCASE:
      return text.toLowerCase();
    case TEXT_CASE.CAPITALIZE:
      return text
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    case TEXT_CASE.TITLES:
      return text
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    default:
      return text;
  }
};

export const generateYearOptions = (range) => {
  const currentYear = new Date().getFullYear();

  const years = [];
  for (let i = 0; i < range; i++) {
      years.push({ label: currentYear - i, value: currentYear - i });
  }
  return years;
};